import React from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import { BoxV2 as Box } from 'portal-commons';
import CampaignsByPrimaryDcas from './CampaignsByPrimaryDcas';
import CampaignsByDcasDeclined from './CampaignsByDcasDeclined';
import { ListingTab } from '../components';
import { TRACKING_REJECTED_CAMPAIGNS } from '@/constants';
import {
  DCA_CAMPAIGNS_PATH,
  DECLINED_DCA_CAMPAIGNS_PATH,
} from '@/constants/paths';

export type TenDlcListingTabKey =
  | 'shared-dca-campaigns'
  | 'declined-dca-campaigns';
export const TenDlcListingTabConfig = {
  items: [
    { key: 'shared-dca-campaigns', label: 'Shared' },
    { key: 'declined-dca-campaigns', label: 'Declined' },
  ],
  routes: {
    'shared-dca-campaigns': {
      pathname: DCA_CAMPAIGNS_PATH,
      search: '?status=ACTIVE&provisional=false',
    },
    'declined-dca-campaigns': {
      pathname: DECLINED_DCA_CAMPAIGNS_PATH,
      search: '?status=ACTIVE&provisional=false',
    },
  },
};

const CampaignsByDcasContainer: React.FC = () => {
  const location = useLocation();
  const history = useHistory();
  const isDeclined = location.pathname === DECLINED_DCA_CAMPAIGNS_PATH;

  const handleTabChange = (tab: string) => {
    const tabLocation =
      TenDlcListingTabConfig.routes[tab as TenDlcListingTabKey];
    if (tabLocation) {
      const { pathname, search } = tabLocation;
      history.push({
        pathname,
        search: search || '',
      });
    }
  };

  return (
    <>
      {TRACKING_REJECTED_CAMPAIGNS && (
        <Box
          sx={{ mt: -15, mb: 20, width: '100%' }}
          data-testid="campaignsByPrimaryDcasListingTab"
        >
          <ListingTab
            items={TenDlcListingTabConfig.items}
            activeTab={
              isDeclined ? 'declined-dca-campaigns' : 'shared-dca-campaigns'
            }
            onTabChange={handleTabChange}
          />
        </Box>
      )}
      {isDeclined ? <CampaignsByDcasDeclined /> : <CampaignsByPrimaryDcas />}
    </>
  );
};

export default CampaignsByDcasContainer;
